import { Box } from '@bechtel/gds';
import styled from 'styled-components';
export const ProjectSelectorStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: '164px';
  height: '32px';
  cursor: pointer;
`;
